export default __webpack_public_path__ + "static/media/Deed of Contract_04.7532a7eb.jpg";